<fieldset [ngClass]="formatter" [attr.aria-describedby]="field.id+'-desc-container'">
  <legend class="bl-font-size--14 bl-font-weight--800 bl-margin-bottom--4" *ngIf="field.label"
    [class.bl-required]="field.enabled && field.required"
    [class.bl-screen-reader-only]="screenReaderOnly(field)">
    {{ field.label }}
    <ng-container *ngIf="field.config.tooltip">
      <button *ngIf="field.config.tooltip && !isArray(field.config.tooltip)" class="bl-font-color--blue bl-margin-left--4" type="button" aria-label="tooltip" attr.aria-describedby="tooltip-info-{{field.id}}">
        <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip }}"></i>
      </button>
      <span id="tooltip-info-{{field.id}}"  class="bl-screen-reader-only">{{field.config.tooltip}}</span>
    </ng-container>
  </legend>
  <p *ngIf="field.config.subLabel">{{ field.config.subLabel }}</p>
  <div class="bl-check-wrap bl-margin-top--4" [class.bl-margin-bottom--8]="!isLast"
  *ngFor="let item of field.enum; let i = index; let isLast = last;">
    <!-- Known bug in Angular 7 and will be reassessed after Angular upgrade: radio group name attribute in chrome -->
    <input type="radio" [cuFieldState]="field" [disabled]="!field.enabled || !card?.enabled" [id]="radioId(i)" [required]="field.required" 
    name="{{field.id}}" attr.name="{{field.id}}" [value]="item.value" [(ngModel)]="field.data.value" (click)="onClick($event)"  [attr.data-automation-id]="field.automationId"/>
    <label class="bl-label" [for]="radioId(i)">{{ item.label }}</label>
    <ng-container *ngIf="field.config.tooltip">
      <button *ngIf="field.config.tooltip && isArray(field.config.tooltip)" class="bl-font-color--blue bl-margin-left--4" type="button" aria-label="tooltip" attr.aria-describedby="tooltip-info-{{field.id}}">
        <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip[i]}}"></i>
      </button>
      <span id="tooltip-info-{{field.id}}"  class="bl-screen-reader-only">{{field.config.tooltip}}</span>
    </ng-container>
    <ng-container *ngIf="isInnerLayout(field)">
      <ng-container *ngFor="let nestedField of field.nestedFields">
        <div *ngIf="nestedField.visible && item?.value?.toString() === field?.data?.value?.toString()"
          [ngClass]="formatter"
          class="bl-margin-top--16 bl-margin-bottom--24 bl-margin-left--8 bl-margin-left-sm--24">
          <cu-dynamic-field [page]="page" [card]="card" [field]="nestedField" [pageSubmitted$]="pageSubmitted$"  *ngIf="field.visible"></cu-dynamic-field>
        </div>
      </ng-container>
    </ng-container>
  </div>
</fieldset>
